import gsap from 'gsap';
import { animateShape } from './helpers';

export const shapesAnimation = () => {
	const shapes = document.querySelector('.gallery-shapes');

	if (!shapes) return;

	const shapesDivs = shapes.querySelectorAll('div');

	gsap.fromTo(
		shapesDivs,
		{ y: 100 },
		{
			y: 0,
			duration: 1,
			ease: 'shapeEasing',
			stagger: 0.1,
			delay: 0.7,
			scrollTrigger: {
				trigger: shapes,
				start: 'top 100%',
				end: 'bottom 20%',
				toggleActions: 'play none none',
			},
		}
	);

	animateShape('.div1', { rotate: 10 });
	animateShape('.div2', { rotate: 10 }, true);
	animateShape('.div3', { rotate: -10 });
	animateShape('.div4', { rotate: -10 });
	animateShape('.div5', { rotate: 10 });
	animateShape('.div6', { rotate: 10 }, true);
	animateShape('.div7', { y: -50 }, true);
	animateShape('.div8', { rotate: -10 }, true);
};
